import React from 'react'
import VisionMissionImage from "../assets/VisionImage.jpg"

const VissionComponent = () => {
  return (
    <div>
      <div className="relative">
        <img className="w-full h-[400px]" src={VisionMissionImage} alt='VisionMissionImage' />
        <div className="absolute inset-0 bg-black bg-opacity-25"></div>
        <div className="absolute backdrop-blur-sm text-center text-white top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <p className='pb-4 font-bold tracking-wide text-2xl lg:text-6xl'>Our Vision and Mission</p>
            <p className='text-center text-md lg:text-lg'>Our vision is to redefine the insurance experience by leveraging technology and personalized service. We believe that insurance should not only protect you but also empower you. Our mission is to offer comprehensive coverage options that are easy to understand and tailored to your unique circumstances.</p>
        </div>
    </div>
    </div>
  )
}

export default VissionComponent
